import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Nouveau modificateur',
  tabs: {
    [Tab.General]: 'Général',
    [Tab.NutritionInfo]: 'Infos nutritionnelles',
  },
  form: {
    modifier_groups: {
      label: 'Appartient aux groupes de modificateurs',
    },
    name: {
      label: 'Nom',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: '{{integration}} réf.',
      placeholder: 'ex. référence SKU HubRise',
      read_only_hint:
        'Modifiable uniquement si une intégration HubRise est connectée et la synchronisation du menu désactivée.',
    },
    price: {
      label: 'Prix de base',
      placeholder: 'Optionnel',
    },
    is_available: {
      label: 'En stock',
    },
    is_visible: {
      label: 'Visible',
      title: 'Visible sur le menu',
      subtitle_on: 'Les clients peuvent voir cette option',
      subtitle_off: 'Masqué pour tous les clients',
    },
    is_available_for_pickup: {
      label: 'Disponible à emporter',
      subtitle_on: 'Les clients peuvent le commander à emporter',
      subtitle_off: 'Masqué du menu à emporter',
    },
    is_available_for_delivery: {
      label: 'Disponible en livraison',
      subtitle_on: 'Les clients peuvent le commander en livraison',
      subtitle_off: 'Masqué du menu de livraison',
    },
  },
  availability: {
    title: 'Disponibilité',
    helper:
      'La visibilité est le commutateur principal. Désactivez un canal pour masquer cette option aux clients à emporter ou en livraison sans la retirer du menu.',
    status: {
      both: 'Les deux canaux',
      pickup_only: 'À emporter uniquement',
      delivery_only: 'Livraison uniquement',
      hidden: 'Masqué',
      no_channels: 'Aucun canal',
    },
    warning: {
      no_channels:
        "Cette option est visible mais n'est disponible sur aucun canal — les clients ne pourront pas la sélectionner.",
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'À emporter uniquement',
      delivery_only: 'Livraison uniquement',
      no_channels: 'Aucun canal',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    changes_got_saved: 'Modifications enregistrées avec succès !',
  },
};
